import { useNavigate } from 'react-router-dom';

import Header from '@/components/globals/Header';
import Wizard from '@/components/shared/Wizard';

import { producerDataSteps } from '../CreateProduct/steps';

const ProducerData = () => {
  const navigate = useNavigate();

  return (
    <Wizard steps={[...producerDataSteps]}>
      <Header onGoBack={() => navigate(-1)} />
      <Wizard.Progress />
      <Wizard.Steps />
    </Wizard>
  );
};

export default ProducerData;
